// Extracted verbatim from the v3 monolith (see BIRDSEYE.md module split plan).

import PandaFilter from './core.js';
import { shouldAutoInit } from './ui-state.js';
import { warnIfOtherBundle } from './diagnostics.js';

// The debug panel ships as a separate file next to this bundle (debug_bundle[.min].js) so
// regular visitors never download it. Resolved now: currentScript is only set while the
// bundle's own <script> runs.
function resolveDebugBundleUrl() {
  var script = document.currentScript;
  var src = script && script.src;
  if (!src) {
    return null;
  }
  return /index_bundle(\.min)?\.js/.test(src)
    ? src.replace(/index_bundle(\.min)?\.js/, 'debug_bundle$1.js')
    : src.replace(/[^/?#]*([?#].*)?$/, 'debug_bundle.min.js');
}

function isDebugRequested() {
  var match = /[?&]pf-debug(?:=([^&#]*))?/.exec(window.location.search);
  return !!match && match[1] !== '0' && match[1] !== 'false';
}

warnIfOtherBundle(window);
window.PandaFilter = PandaFilter;

PandaFilter.debugBundleUrl = resolveDebugBundleUrl();

// Opens the debug panel (?pf-debug=1 does this on load). Fails loud when the panel file
// cannot be located or fetched — never silently.
PandaFilter.debug = function () {
  if (window.PandaFilterDebug) {
    window.PandaFilterDebug.open();
    return;
  }
  if (!PandaFilter.debugBundleUrl) {
    console.warn('[PandaFilter] Debug panel location unknown — set PandaFilter.debugBundleUrl, then call PandaFilter.debug().');
    return;
  }
  if (document.querySelector('script[data-pf-debug-loader]')) {
    return;
  }
  var tag = document.createElement('script');
  tag.src = PandaFilter.debugBundleUrl;
  tag.setAttribute('data-pf-debug-loader', '');
  tag.onerror = function () {
    tag.remove();
    console.warn('[PandaFilter] Could not load the debug panel from ' + PandaFilter.debugBundleUrl);
  };
  document.head.appendChild(tag);
};

function start() {
  PandaFilter.initAll();
  if (isDebugRequested()) {
    PandaFilter.debug();
  }
}

if (shouldAutoInit()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
} else if (isDebugRequested()) {
  // Manual-init pages: the panel still opens; it shows whatever instances exist by then.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', PandaFilter.debug);
  } else {
    PandaFilter.debug();
  }
}
